// Off screen filters

var $ = jQuery;
/* Set the width of the side navigation to 300px*/
function openNav() {
	$('#show-filter_wrapper').css('width', '300px');
	$('#show-filter_wrapper').css('opacity', '1');
	$('body').toggleClass('overlay');
}

/* Set the width of the side navigation to 0 */
function closeNav() {
	$('#show-filter_wrapper').css('width', '0');
	$('body').removeClass('overlay');
}

$(document).click(function (event) {
	//if you click on anything except the modal itself or the "open modal" link, close the modal
	if (
		!$(event.target).closest('#show-filter_wrapper, #show-filter_button')
			.length &&
		$(window).width() < 992
	) {
		$('#show-filter_wrapper').css('width', '0');
		$('#show-filter_wrapper').css('opacity', '0');
		$('body').removeClass('overlay');
	}
});

// Scale iframes based on parent width
jQuery(window).load(function () {
	var $scalable = $('.ads__html>div');
	if ($scalable) {
		var parentWidth = $scalable.parent().width();
		var currentWidth = $scalable.width();

		var scale = parentWidth / currentWidth;

		if (scale > 0 && scale < 1) {
			$scalable.css('transform', 'scale(' + scale + ')');
			console.log('Scale pls');
		}
	}
});

// Accordion
jQuery(document).ready(function () {
	var $ = jQuery;
	var acc = $('.accordion__header');
	var i;

	for (i = 0; i < acc.length; i++) {
		acc[i].addEventListener('click', function () {
			this.classList.toggle('active');
			var panel = this.nextElementSibling;
			if (panel.style.maxHeight) {
				panel.style.maxHeight = null;
			} else {
				panel.style.maxHeight = panel.scrollHeight + 'px';
			}
		});
	}

	$('.ads iframe').each(function () {
		$(this).load(function () {
			$(this).height($(this).contents().height());
		});
	});

	//Sets fixed sidebar on scroll
	var offsetElement = $(
		'.magazine__sidebar, .article__sidebar, .all_magazine__sidebar, #show-filter_button, .fix-on-scroll'
	);
	if (offsetElement.length) {
		var elementPosition = offsetElement.offset();

		$(window).scroll(function () {

			if(offsetElement.hasClass('no-fixed')){
				return;
			}

			if ($(window).scrollTop() > elementPosition.top) {
				offsetElement.addClass('fixed');
				// No need for placeholder with sticky positioning
			} else {
				offsetElement.removeClass('fixed');
			}
		});
	}

	// ==============================
	// Show more link on images
	// ==============================
	const captions = $('figcaption');

	// add link to figure captions
	for (let i = 0; i < captions.length; i++) {
		const link = $("<a class='captions-link' style='display:none;'></a>");

		$(captions[i]).after(link);
	}

	$('.captions-link').click(function (e) {
		$(e.target).siblings().toggleClass('show');
	});

	// ==============================
	// Countdown to next release
	// ==============================
	if ($('.neste-utgave__start-date').length) {
		// Set the date we're counting down to
		var $date = $('.neste-utgave__start-date').val();
		var countDownDate = new Date($date).getTime();

		// Update the count down every 1 second
		var x = setInterval(function () {
			// Get todays date and time
			var now = new Date().getTime();

			// Find the distance between now and the count down date
			var distance = countDownDate - now;

			// Time calculations for days, hours, minutes and seconds
			var days = Math.floor(distance / (1000 * 60 * 60 * 24));
			var hours = Math.floor(
				(distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
			);
			var minutes = Math.floor(
				(distance % (1000 * 60 * 60)) / (1000 * 60)
			);

			$('.neste-utgave__day').text(('0' + days).slice(-2));
			$('.neste-utgave__hour').text(('0' + hours).slice(-2));
			$('.neste-utgave__min').text(('0' + minutes).slice(-2));

			// If the count down is over, write some text
			if (distance < 0) {
				clearInterval(x);
				$('.neste-utgave__date').text('00:00:00');
			}
		}, 1000);
	}

	// ==============================
	//  Ads tracking
	// ==============================

	// Tracks first click on regular ads
	$('.ads').one('click', function (e) {
		var adName = $(this).data('name');
		var url = window.location.href;
		sendClickTrack(adName, url, 'annonseklikk');
	});

	// Tracks first click on HTML/iFrame ads
	var monitor = setInterval(function () {
		var elem = document.activeElement;
		if (elem && elem.tagName == 'IFRAME') {
			clearInterval(monitor);
			var ads = $(elem).parents('.ads');
			var value = $(ads).data('name');
			var url = window.location.href;
			sendClickTrack(value, url, 'annonseklikk');
		}
	}, 100);

	function sendClickTrack(adName, adUrl, adCat) {
		dataLayer.push({ event: adCat, navn: adName, side: adUrl });
	}

	// Check if element is in view
	var $window = $(window);
	$window.on('scroll', check_if_in_view);
	$window.on('scroll resize', check_if_in_view);
	$window.trigger('scroll');

	function check_if_in_view() {
		var $animation_elements = $('.ads');

		var window_height = $window.height();
		var window_top_position = $window.scrollTop();
		var window_bottom_position = window_top_position + window_height;

		$.each($animation_elements, function () {
			var $element = $(this);
			var element_height = $element.outerHeight();
			var element_top_position = $element.offset().top;
			var element_bottom_position = element_top_position + element_height;

			//check to see if this current container is within viewport
			if (
				element_bottom_position >= window_top_position &&
				element_top_position <= window_bottom_position
			) {
				var adName = $element.data('name');
				var url = window.location.href;
				sendClickTrack(adName, url, 'annonsevisning');
			} else {
				//$element.removeClass('in-view');
			}
		});
	}

	$('.af-field-instructions').each(function () {
		var target = $(this).parent().siblings('.acf-input');
		var ele = $(this).detach();
		target.append(ele);
	});

	// Copy article url
	$('.share-link.button').click(function () {
		var text = $(this).find('#copyInput');
		console.log(text);
		text.select();
		/* Copy the text inside the text field */
		document.execCommand('copy');
		alert('Lenken ble kopiert');
	});

	$('.fact-box').each(function () {
		var $this = $(this);

		var inner = $this.find('.fact-box__inner');
		inner.css('max-height', '140px');

		$this.find('.show-more').on('click', function () {
			inner.css('max-height', '100%');
			$this.find('.show-more').remove();
		});
	});

	$('.menu-search-button').click(function (e) {
		e.preventDefault();
		$('.search.form-container').toggleClass('active');
		if ($('.search.form-container').hasClass('active')) {
			$('.search.form-container input').focus();
			$('.menu-search-button a').text('Lukk');
		} else {
			$('.menu-search-button a').text('Søk');
		}
	});
	(function () {
		'use strict';
		function r() {
			function e() {
				var r = {
						width: u.width / u.naturalWidth,
						height: u.height / u.naturalHeight
					},
					a = {
						width: parseInt(
							window
								.getComputedStyle(u, null)
								.getPropertyValue('padding-left'),
							10
						),
						height: parseInt(
							window
								.getComputedStyle(u, null)
								.getPropertyValue('padding-top'),
							10
						)
					};
				i.forEach(function (e, t) {
					var n = 0;
					o[t].coords = e
						.split(',')
						.map(function (e) {
							var t = 1 == (n = 1 - n) ? 'width' : 'height';
							return a[t] + Math.floor(Number(e) * r[t]);
						})
						.join(',');
				});
			}
			function t(e) {
				return e.coords.replace(/ *, */g, ',').replace(/ +/g, ',');
			}
			function n() {
				clearTimeout(d), (d = setTimeout(e, 250));
			}
			function r(e) {
				return document.querySelector('img[usemap="' + e + '"]');
			}
			var a = this,
				o = null,
				i = null,
				u = null,
				d = null;
			'function' != typeof a._resize
				? ((o = a.getElementsByTagName('area')),
					(i = Array.prototype.map.call(o, t)),
					(u = r('#' + a.name) || r(a.name)),
					(a._resize = e),
					u.addEventListener('load', e, !1),
					window.addEventListener('focus', e, !1),
					window.addEventListener('resize', n, !1),
					window.addEventListener('readystatechange', e, !1),
					document.addEventListener('fullscreenchange', e, !1),
					(u.width === u.naturalWidth &&
						u.height === u.naturalHeight) ||
						e())
				: a._resize();
		}
		function e() {
			function t(e) {
				e &&
					(!(function (e) {
						if (!e.tagName)
							throw new TypeError(
								'Object is not a valid DOM element'
							);
						if ('MAP' !== e.tagName.toUpperCase())
							throw new TypeError(
								'Expected <MAP> tag, found <' + e.tagName + '>.'
							);
					})(e),
					r.call(e),
					n.push(e));
			}
			var n;
			return function (e) {
				switch (((n = []), typeof e)) {
					case 'undefined':
					case 'string':
						Array.prototype.forEach.call(
							document.querySelectorAll(e || 'map'),
							t
						);
						break;
					case 'object':
						t(e);
						break;
					default:
						throw new TypeError(
							'Unexpected data type (' + typeof e + ').'
						);
				}
				return n;
			};
		}
		if (typeof define === 'function' && define.amd) {
			define([], e);
		} else if (
			typeof module === 'object' &&
			typeof module.exports === 'object'
		) {
			module.exports = e();
		} else {
			window.imageMapResize = e();
		}

		if ('jQuery' in window) {
			window.jQuery.fn.imageMapResize = function () {
				return this.filter('map').each(r).end();
			};
		}
	})();

	document.addEventListener('DOMContentLoaded', () => {
		if (typeof window.imageMapResize === 'function') {
			window.imageMapResize();
		}
	});
});
